import React, { useState } from 'react';

import {
    mobileSupportPageSignal,
    mobileSupportRetryPageSignal,
} from 'features/mobile-report/state/mobile-report.signals';
import { Button } from 'ui-components/button/button';
import { LeftArrowIcon } from 'components/assets/Icons/IconsMobile';
import { InputField } from '@placer-ui/components';

import styles from './mobile-support-pages.module.scss';
import { supportApi } from 'API/offline-reports-api';

export const RequestLocationMobile = () => {
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [isSendingRequest, setIsSendingRequest] = useState(false);

    const handleClose = () => {
        mobileSupportPageSignal.value = undefined;
    };

    const handleApply = async () => {
        setIsSendingRequest(true);
        try {
            await supportApi.submitRequest({
                type: 'property_single',
                poiName: name,
                address,
                zip_code: zipCode,
                isMobile: true,
            });
            setIsSendingRequest(false);
            mobileSupportPageSignal.value = 'success';
        } catch (e) {
            setIsSendingRequest(false);
            mobileSupportRetryPageSignal.value = 'requestLocation';
            mobileSupportPageSignal.value = 'failed';
        }
    };

    return (
        <>
            <div className={styles.header}>
                <Button
                    data-testid="customize-back-button"
                    type="link"
                    className={styles.backIcon}
                    onClick={handleClose}
                >
                    <LeftArrowIcon />
                </Button>
                <div className={styles.heading}>
                    <h2 className={styles.title}>Request a Single Property</h2>
                </div>
            </div>
            <div className={styles.contactForm}>
                <div>
                    <InputField
                        value={name}
                        name="poiName"
                        onChange={setName}
                        label="Property Name"
                        placeholder="Type property name"
                        maxLength={100}
                        required
                        asterix
                        testId="request-location-mobile-name"
                    />
                </div>
                <div>
                    <InputField
                        value={address}
                        name="poiAddress"
                        onChange={setAddress}
                        label="Address"
                        placeholder="Property Address"
                        maxLength={150}
                        required
                        asterix
                        testId="request-location-mobile-address"
                    />
                </div>
                <div>
                    <InputField
                        value={zipCode}
                        onChange={setZipCode}
                        label="Zip Code (Optional)"
                        placeholder="Property Zip Code"
                        maxLength={100}
                        testId="request-location-mobile-zip-code"
                    />
                </div>
            </div>

            <Button
                className={styles.mainButton}
                type="primary"
                onClick={handleApply}
                disabled={!name || !address || isSendingRequest}
                loading={isSendingRequest}
                data-testid="ask-support-mobile-submit"
            >
                Submit
            </Button>
        </>
    );
};
